<template>
  <PublicView :key="this.$route.params.make">
    <main class="main">
        <div class="service-area service-bg py-120">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mx-auto">
                        <div class="site-heading text-center">
                            <span class="site-title-tagline">Azzura</span>
                            <h2 class="site-title">Khóa học của <span>Azzura</span></h2>
                            <div class="heading-divider"></div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-6 col-lg-4" v-for="p in products" :key="p._id">
                        <div class="service-item">
                            <div class="service-img">
                                
                      <ImgThumb :src="p.avatar" width="351" height="234" />
                            </div>
                            <div class="service-icon">
                                <i :class="p.icon"></i>
                            </div>
                            <div class="service-content">
                                <h3 class="service-title">
                                    <router-link :to="productLink(p._id, p.alias)" >{{ p.name }}</router-link>
                                </h3>
                                <p class="service-text">
                                    {{ p.shortDescription }}
                                </p>
                                <div class="service-arrow">
                                    <router-link :to="productLink(p._id, p.alias)" class="theme-btn">Tìm hiểu thêm <i class="far fa-arrow-right"></i></router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>
  </PublicView>
</template>
<script>
const axios = require("axios").default;

import ImgThumb from "@/components/Shared/ImgThumb.vue";
import PublicView from "@/components/PublicView.vue";
export default {
  data() {
    return {
      make: [],
      show: {},
      filter: {},
      sort: 1,
      query: "",
      select: null,
      model: null,
      page: 1,
    };
  },
  components: {
    PublicView,
    ImgThumb,
  },
  mounted() {
    this.getMake();
    document.querySelector("title").innerText = "Azzura.vn - Cựa hàng Azzura";
    if (this.$route.params.make) {
      this.select = decodeURIComponent(this.$route.params.make);
      this.model = null;
      this.show[decodeURIComponent(this.$route.params.make)] = true;
      this.filter.parent = decodeURIComponent(this.$route.params.make);
      this.filter.select = null;
    }
  },
  onUpdated() { },
  computed: {
    products() {
      return this.$store.getters.khoaHoc;
    },
  },
  watch: {
  },
  methods: {
    productLink(id, alias) {
        console.log(id, alias)
      return "/khoa-hoc/" + alias + "/" + id;
    },
    version(year, pre = "") {
      let result = [];
      for (let i = 0; i < year.length; i++) {
        let text = year[i].year;
        let vers = [];
        for (let ver in year[i].versions) {
          vers.push(year[i].versions[ver].v);
        }
        if (vers.length > 0) {
          result.push(vers.map((i) => pre + i + " " + text).join(", "));
        } else {
          result.push(text);
        }
      }
      return result.length > 0 ? "(" + result.join(", ") + ")" : "";
    },
    numberFormat(num) {
      return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }).format(num);
    },
    selectMake(makeName) {
      this.select = makeName;
      this.model = null;
      if (makeName != null) {
        this.filter.make = makeName;
      } else {
        delete this.filter.make;
      }
    },
    selectModel(makeName, modelName) {
      console.log("selectModel");
      this.select = null;
      this.model = makeName + modelName;
      console.log(this.model);
      this.filter = { make: makeName.toLowerCase(), model: modelName };
    },
    isSelectModel(makeName, modelName) {
      return this.model == makeName + modelName;
    },
    showMakeStatus(name) {
      if (typeof this.show[name] == "undefined") {
        return false;
      } else {
        return this.show[name];
      }
    },
    toggleShowMake(name) {
      if (typeof this.show[name] == "undefined") {
        this.show[name] = true;
      } else {
        this.show[name] = !this.show[name];
      }
      console.log(this.show[name]);
    },
    async getMake() {
      try {
        let res = await axios.get("/api/make");
        this.make = res.data;
        for (let i = 0; i < this.make.length; i++) {
          this.show[this.make[i].name] = false;
        }
      } catch {
        console;
      }
    },
  },
};
</script>

<style lang="less">
.page-item {
  cursor: pointer;
}

.shop-widget.make-filter {
  .ul-make {
    text-align: left;

    >li {
      margin: 0;

      .title-wrap {
        display: flex;
        cursor: pointer;

        .make {
          flex: 1;

          &.select {
            color: #2db7ff;
          }
        }

        .show {
          i::before {
            content: "\f078";
          }

          &.d {
            i::before {
              content: "\f077";
            }
          }
        }
      }

      ul {
        margin: 0;
        max-height: 0;
        overflow: hidden;
        transition: 1s max-height;

        &.show {
          max-height: initial;
        }

        >li {
          margin: 0;
          cursor: pointer;

          &.select {
            color: #2db7ff;
          }
        }
      }
    }
  }
}
</style>